import React from 'react';
import { ArrowIcon, TickIcon } from '../icons';

/**
 * What LightBox now says versus what iCLIMB holds, field by field.
 *
 * Nothing is written without a tick: an agent may have set a value on purpose,
 * so a refresh offers changes rather than making them.
 */
export default function UpdateStep({ rows, isLoading, error, rejected, isSaving, onToggle, onAcceptAll, onApply }) {
    if (isLoading) return <div className="SidePanel-loading">Checking LightBox…</div>;

    // Shown here rather than as a toast over the summary: the user asked to
    // see this property's diff, so the answer belongs where they asked for it.
    if (error) return <div className="SidePanel-empty">{error}</div>;

    if (rows.length === 0) {
        return <div className="SidePanel-empty">Nothing to update.<br />iCLIMB already matches LightBox.</div>;
    }

    const acceptedCount = rows.filter((row) => !rejected[row.key]).length;

    return (
        <div className="SidePanel-step">
            <div className="Diff-head">
                <div className="Diff-count">
                    {rows.length} field{rows.length === 1 ? '' : 's'} differ · {acceptedCount} selected
                </div>
                <button type="button" className="Btn Btn--sm" onClick={onAcceptAll}>Accept all</button>
            </div>

            <div className="SidePanel-body">
                {rows.map((row) => {
                    const on = !rejected[row.key];

                    return (
                        <div key={row.key} className="Diff-row" onClick={() => onToggle(row.key)}>
                            <div className={'Check' + (on ? ' Check--on' : '')}><TickIcon /></div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div className="Diff-label">{row.label}</div>
                                <div className="Diff-values">
                                    <span className="Diff-current">{row.current || '—'}</span>
                                    <ArrowIcon />
                                    <span className="Diff-incoming">{row.incoming}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="SidePanel-footer">
                <button
                    type="button"
                    className="Btn Btn--grow Btn--primary"
                    onClick={onApply}
                    disabled={isSaving || acceptedCount === 0}
                >
                    {isSaving ? 'Applying…' : 'Apply ' + acceptedCount + ' change' + (acceptedCount === 1 ? '' : 's')}
                </button>
            </div>
        </div>
    );
}
